import { get12306Tickets } from '@/api/tickets12306'
import { innerRouter, pagePath } from '@/common/jump'
import { mpx } from '@didi/es-mpx-creator'
import { formatDate } from '@didi/es-mpx-shared/lib/date'
import store from "@/store";

// 获取个人信息收集清单
export async function get12306TicketsAction ({ state, commit }, payload) {
  try {
    const photos = state.photos12306
    const pageIndex = payload?.pageIndex || 1
    const { data, code, message } = await get12306Tickets({ photos, pageIndex })
    commit('setPhotos12306', undefined)
    if (code === '988') {
      // 需要拉起人脸核验
      commit('setShowVerification', true)
      return
    } else if (code === '0' && data?.self_tickets?.length) {
      const passengerInfo = data.passengerInfo
      const ticketsList = data.self_tickets.map((item) => {
        item.status_color = '#999999'
        const start_time = Number(new Date(item.start_date + ' ' + item.start_time).getTime())
        const week = ['日', '一', '二', '三', '四', '五', '六']?.[new Date(start_time)?.getDay()]
        item.start_time_format = formatDate(start_time, 'M月dd日 周' + week + ' hh:mm ')
        item.start_time = item.start_date + ' ' + item.start_time
        item.arrive_time = item.arrive_date + ' ' + item.arrive_time
        item.seat_type = item.seat_name
        item.seat_name = item.seat_code
        item.coach_no = item.coach_name?.slice(0, -2)
        item.travel_time_name = '历时' + item.travel_time
        item.passenger_id_type_name = passengerInfo.id_type_name
        return item
      })
      commit('setTickets12306List', pageIndex === 1 ? ticketsList : state.tickets12306List?.concat(ticketsList))
      commit('setPassengerInfo', passengerInfo)
      commit('setTotalPage', data.totalPage)
      setTimeout(() => {
        innerRouter.push(pagePath().TICKETS12306LIST)
      }, 300)
    } else if(code === '10603' || code === '10607' || code === '10602') {
      commit('setTickets12306NeedCheck', true)
      // 命中12306登录核验，走原有登录核验流程
      store.commit("login12306.setChangeCode", { code, type: 1 });
    } else {
      mpx.showToast({
        title: message,
        icon: "error",
        duration: 2000,
        mask: true,
      });
    }
  } catch (e) {
    console.log(e)
  }
}

export default {
  get12306TicketsAction,
}
